<script>
import Layout from "@/layouts/main";


export default {
  name: "auditReport",
  data() {
   return {

   }
  },
  components: {
 
    Layout,
  
  },
  computed: {
     imgUrl(){
        var language = localStorage.getItem('language')
      
        var model = localStorage.getItem('deviceProfileName')
      return language == 'en'?require(model.includes('2BE1')?'./R2BE1C.svg':'./RTC11E.svg'):require(model.includes('2BE1')?'./R2BE1E.svg':'./RTC11C.svg')
    }
  },
  mounted() {
  },

  activated() {
  },
  methods: {
  
  },
 
};
</script>

<template>
  <Layout>
       <img style="height:100%;width:100%" :src="imgUrl" alt="">
  </Layout>
</template>
